<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg
      v-if="exceptionMsg"
      :msg="exceptionMsg"
      :image="exceptionImg"
    />

    <div
      v-if="
        contractForms.contractFormsData != undefined &&
        contractForms.contractFormsData.length != 0
      "
    >
      <ContractFormsTable
        v-on:setContractForm="contractForms.contractForm.fillData($event)"
        :contractForms="contractForms.contractFormsData"
        :pagination="contractForms.pagination"
      />

      <Pagination
        v-if="!isLoading"
        :paginationData="contractForms.pagination"
        v-on:changePage="changePage"
      />
      <ContractFormInfo :contractForm="contractForms.contractForm" />
      <ContractFormDelete
        :contractForm="contractForms.contractForm"
        v-on:refresh="getAllContractForms()"
      />
    </div>

    <ContractFormBtns
      :theFilterData="contractForms.filterData"
      v-on:search="search($event)"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import ContractFormsTable from "@/components/settings/settingsSalary/contractForms/ContractFormsTable.vue";
import ContractFormInfo from "@/components/settings/settingsSalary/contractForms/ContractFormInfo.vue";
import ContractFormDelete from "@/components/settings/settingsSalary/contractForms/ContractFormDelete.vue";
import ContractFormBtns from "@/components/settings/settingsSalary/contractForms/ContractFormBtns.vue";
import Pagination from "@/components/general/Pagination.vue";
import ContractForms from "@/models/settings/settingsSalary/contractForms/ContractForms";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    ContractFormsTable,
    ContractFormInfo,
    ContractFormDelete,
    ContractFormBtns,
    Pagination,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken,
      language: localStorage.getItem("userLanguage") || "ar",
      contractForms: new ContractForms(),
    };
  },
  methods: {
    changePage(page) {
      this.contractForms.pagination.selfPage = page;
      this.getAllContractForms();
    },
    search(data) {
      this.contractForms.filterData.fillData(data);
      this.contractForms.contractFormsData = [];
      this.getAllContractForms();
    },
    async getAllContractForms() {
      this.isLoading = true;
      try {
        const response =
          await this.contractForms.contractForm.getAllContractForms(
            this.language,
            this.userAuthorizeToken,
            this.contractForms.pagination,
            this.contractForms.filterData
          );

        if (response.data.status == STATUS.SUCCESS) {
          this.exceptionMsg = null;
          this.contractForms.fillData(response.data);
        } else if (response.data.status == STATUS.NO_CONTENT) {
          this.contractForms.contractFormsData = [];
          this.exceptionImg = "";
          this.exceptionMsg = response.data.msg;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.contractForms.contractFormsData = [];
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.contractForms.contractFormsData = [];
          this.exceptionImg = "illustrator-api-catch.svg";
          this.exceptionMsg = response.data.msg;
        }
      } catch (error) {
        this.contractForms.contractFormsData = [];
        this.exceptionImg = "illustrator-somethingWrong.svg";
        this.exceptionMsg = this.$t("errorCatch");
      }
      this.isLoading = false;
    },
  },
  computed: {},
  async created() {
    this.getAllContractForms();
  },
};
</script>
